import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  menusState: {
    header: {
      isFetching: false,
      isFetched: false,
      isFailed: false,
      errorMessage: '',
      items: [],
    },
  },
}

export const commonSlice = createSlice({
  name: 'common',
  initialState: initialState,
  reducers: {
    getMenuRequest: (state: any, action) => {
      state.menusState[action.payload.type].isFetching = true
      state.menusState[action.payload.type].isFetched = false
      state.menusState[action.payload.type].isFailed = false
      state.menusState[action.payload.type].errorMessage = ''
    },
    getMenuSuccess: (state: any, action) => {
      state.menusState[action.payload.type].isFetching = false
      state.menusState[action.payload.type].isFetched = true
      state.menusState[action.payload.type].items = action.payload.items
    },
    getMenuFailure: (state: any, action) => {
      state.menusState[action.payload.type].isFetching = false
      state.menusState[action.payload.type].isFetched = true
      state.menusState[action.payload.type].isFailed = true
      state.menusState[action.payload.type].errorMessage =
        action.payload.errorMessage
    },
  },
})

export const { getMenuRequest, getMenuSuccess, getMenuFailure } =
  commonSlice.actions

export default commonSlice.reducer
